import React, { Component } from 'react'
import { connect } from 'react-redux'

// import '@/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area/virtual-trading-area-bottom.scss'
import classnames from 'classnames';

import DataTable from '@/components/DataTable/DataTable';
import { dataType } from '@/constants/data-type';

 class VirtualTradingAreaBottom extends Component {
     constructor(props){
         super(props)
         this.state={
            HistoryColDefs:[
                {
                    headerName: props.language.common_order_id,
                    colId: 'virtual_order_id',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    resizable:true,
                    width:79,
                },
                {
                    headerName: props.language.common_symbol,
                    colId: 'virtual_symbol',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    width:79,
                },
                {
                    headerName: props.language.common_name,
                    colId: 'virtual_name',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    width:201,
                },
                {
                    headerName: props.language.common_buy_sell,
                    colId: 'virtual_buy_sell',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    width:67,
                },
                {
                    headerName: props.language.common_price,
                    colId: 'virtual_price',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    width:67,
                },
                {
                    headerName: props.language.common_quantity,
                    colId: 'virtual_quantity',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    width:67,
                },
                {
                    headerName: props.language.common_amount,
                    colId: 'virtual_amount',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    width:85,
                },
                {
                    headerName: props.language.common_order_time,
                    colId: 'virtual_order_time',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT,
                    width:135,
                },
            ],
            HistoryData:[],
            selectBlock:['transaction_history_title','portfolio_title'],
            activeBlock:0,
         }
     }
    render() {
        const {selectBlock,activeBlock,HistoryColDefs,HistoryData} = this.state
        const {language} = this.props
        return (
            <div className='virtual-trading-area-bottom' >
                <div className='vtab-head' >
                    {selectBlock.map((item,index)=>{
                        return(
                            <div className={classnames('head-block',activeBlock == index ? 'active-block' : '')} 
                            key={item} onClick={() => this.handleActiveBlock(index)} > {language[item]} </div>
                        )
                    })}
                </div>
                <div className='vtab-table'>
                   { activeBlock == 0 &&  <DataTable
                    columnDefs={HistoryColDefs}
                    innerRef={e => this.HistoryRef = e}
                    showPagination={false}
                    data={HistoryData}
                    /> }
                    {   activeBlock == 1 &&
                        ''
                    }
                </div>
            </div>
        )
    }
    handleActiveBlock=(index)=>{
        this.setState({activeBlock:index})
    }
}

export default connect(state =>({
    language: state.app.language,
}),dispatch =>({

}))(VirtualTradingAreaBottom)
